import { apiClient } from "@finitless/shared/lib";
import { useApiStore } from "@finitless/shared/stores";

export function getLinkInBioAdminFunctionUrl() {
  const explicit = import.meta.env.VITE_LINK_IN_BIO_ADMIN_FUNCTION_URL;
  if (explicit) {
    return String(explicit).replace(/\/$/, "");
  }
  const base = import.meta.env.VITE_SUPABASE_URL?.replace(/\/$/, "");
  if (!base) {
    return null;
  }
  return `${base}/functions/v1/link-in-bio-admin`;
}

/**
 * @param {"get" | "list" | "list_all" | "upsert" | "check_slug" | "archive" | "delete" | "set_enabled"} action
 * @param {Record<string, unknown>} payload
 * @returns {Promise<Record<string, unknown>>}
 */
export async function invokeLinkInBioAdmin(action, payload = {}) {
  const url = getLinkInBioAdminFunctionUrl();
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
  const token = apiClient.getAuthToken();
  const projectRaw = useApiStore.getState().project;
  const project =
    projectRaw != null && String(projectRaw).trim() !== ""
      ? String(projectRaw).trim()
      : "";

  if (!url || !anonKey) {
    const err = new Error("LINK_IN_BIO_ADMIN_CONFIG");
    err.code = "LINK_IN_BIO_ADMIN_CONFIG";
    throw err;
  }
  if (!token) {
    const err = new Error("LINK_IN_BIO_ADMIN_AUTH");
    err.code = "LINK_IN_BIO_ADMIN_AUTH";
    throw err;
  }
  if (!project) {
    const err = new Error("LINK_IN_BIO_MISSING_PROJECT");
    err.code = "LINK_IN_BIO_MISSING_PROJECT";
    throw err;
  }

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${anonKey}`,
      apikey: anonKey,
      "x-finitless-token": token,
    },
    body: JSON.stringify({ action, ...payload, project }),
  });

  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json.error || `HTTP ${res.status}`);
    err.status = res.status;
    err.data = json;
    throw err;
  }
  return json;
}
